const ToggleSwitchComponent = ({
  isOn = false,
  handleSwitchChange,
  bgColor = "bg-darwin-neutral-100",
  checkedBgColor = "bg-darwin-primary-300",
  uncheckedDotColor = "bg-neutral-0 shadow-100",
  checkedDotColor = "bg-darwin-primary-500",
  toggleId = "toggle",
}: {
  isOn: boolean;
  handleSwitchChange: () => void;
  bgColor?: string;
  checkedBgColor?: string;
  uncheckedDotColor?: string;
  checkedDotColor?: string;
  toggleId: string;
}) => {
  return (
    <label htmlFor={toggleId} className="flex items-center cursor-pointer">
      <div className="relative">
        <input
          type="checkbox"
          id={toggleId}
          className="sr-only"
          checked={isOn}
          readOnly={true}
          onClick={handleSwitchChange}
        />
        <div
          className={`block w-40 h-15 rounded-full ${
            isOn ? checkedBgColor : bgColor
          }`}
        />
        <div
          className={`absolute -top-2 w-20 h-20 rounded-full transition ${
            isOn ? `translate-x-full ${checkedDotColor}` : uncheckedDotColor
          }`}
          style={
            isOn
              ? {
                  transform: "translateX(100%)",
                }
              : {}
          }
        />
      </div>
    </label>
  );
};

export default ToggleSwitchComponent;
